__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "spm-ts";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			initExternal(19289);
			initExternal(94875);
			initExternal(76982);
			initExternal(95331);
			initExternal(63677);
			initExternal(97460);
			initExternal(83059);
			initExternal(94610);
			initExternal(46684);
			initExternal(50014);
			initExternal(43677);
			initExternal(46234);
			initExternal(42668);
			initExternal(55727);
			initExternal(90715);
			initExternal(64049);
			initExternal(48808);
			initExternal(20210);
			initExternal(56796);
			initExternal(23951);
			initExternal(2340);
			initExternal(96422);
			initExternal(74897);
			initExternal(18399);
			initExternal(38747);
			initExternal(49874);
			initExternal(7067);
			initExternal(24042);
			initExternal(71610);
			initExternal(50958);
			initExternal(37583);
			initExternal(19865);
			initExternal(78170);
			initExternal(36145);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};